import React from 'react';
import Contact from '../Home/Contact/Contact';
import Navbar from '../Shared/Navbar/Navbar';

const ContactUs = () => {
    return (
        <div>
            <Navbar></Navbar>
            <Contact></Contact>
        </div>
    );
};

export default ContactUs;